module.exports = __webpack_public_path__ + "img/TradingView-img7.f3b17ff2.png";